module.exports = __webpack_public_path__ + "img/raised_hand.75bfeead.png";